/**
 * Loads the Unbounce tracking script and tracks conversions with Unbounce.
 * See https://documentation.unbounce.com/hc/en-us/articles/19956511113876-External-Conversion-Tracking-with-Unbounce
 */

import { MiaPlaza } from "@/Reinforced.Typings";
import { ScriptLoader } from "@/utils/ScriptLoader";

interface WindowWithUnbounce extends Window {
	_ubad?: string
	_ubaq?: string[][]
}

declare const window: WindowWithUnbounce;

export default class Unbounce {
	private readonly options: MiaPlaza.Control.Tracking.IUnbounceTrackingOptions;
	private loaded = false;

	constructor(options: MiaPlaza.Control.Tracking.IUnbounceTrackingOptions) {
		this.options = options;
	}

	public load(): void {
		if (this.loaded) {
			return;
		}
		this.loaded = true;

		if (!this.options.Domain) {
			return;
		}

		window._ubad = this.options.Domain;
		window._ubaq = (window._ubaq || []);
		window._ubaq.push(["trackGoal"]);

		/* Note that this external tracking script is noisy and logs to the console instead of throwing errors. E.g. it
		   logs an error message when the unbounce cookie ubvt is not defined, however if customers do not come through
		   unbounce the cookie could not have been set. */
		ScriptLoader.LoadScript(`//${this.options.Domain}/_ub/static/ets/t.js`);
	}
}
